import { render } from "./CAddPage.vue?vue&type=template&id=95baa7a2"
import script from "./CAddPage.vue?vue&type=script&lang=js"
export * from "./CAddPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__